document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver((mutations, obs) => {
    const container = document.querySelector('.device-compatibility-container');
    if (!container) return;

    const typeformBtn = container.querySelector(
      '.tf-v1-button, [data-tf-popup], [data-tf-button] button',
    );

    if (typeformBtn) {
      if (typeformBtn.closest('div')?.classList.contains('esim-checker-desktop')) {
        if (window.innerWidth < 768) {
          typeformBtn.innerHTML = `<span class="check-device-comp">Check device compatibility <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
<path d="M1.5 8H18M18 8L11 1M18 8L11 15" stroke="#0C1924" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg></span>`;
        } else {
          typeformBtn.innerHTML = `<span class="check-device-comp">Check if your device is compatible with eSIM <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
<path d="M1.5 8H18M18 8L11 1M18 8L11 15" stroke="#0C1924" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg></span>`;
        }
      }

      obs.disconnect();
    }
  });

  // Start observing the body for dynamically added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  const desktopDiv = document.querySelector('.esim-checker-desktop');

  function desktopCompatibility() {
    showTypeformInline(desktopDiv, true);
  }

  if (desktopDiv) {
    desktopCompatibility();
    return;
  }
});
